import {createFeatureSelector} from "@ngrx/store";
import {GlobalState} from "./reducers";
export const globalStateFeatureKey = 'globalState';
export const globalStateFeatureSelector = createFeatureSelector<GlobalState>(
    globalStateFeatureKey
);